import * as React from 'react';
import {
  PromptChip,
  BodyMedium,
  TitleMedium,
  Icon,
} from '@spaced-out/ui-design-system';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import css from './workflow.css';


export type WorkflowStartScreenProps = {
  source?: string;
  onSelectPrompt: (text: string) => void;
};

const prompts: {label: string; value: string}[] = [
  {
    label: 'Review checklist before activating workflow',
    value: 'Review checklist before activating workflow',
  },
  {label: 'How to add recurring node?', value: 'How to add recurring node?'},
  {label: 'What are blackout settings?', value: 'What are blackout settings?'},
];

export const WorkflowStartScreen: React.FC<WorkflowStartScreenProps> = ({
  onSelectPrompt,
}) => {
  const {t} = useLabelTranslation();
  return (
    <div className={css.container}>
      <div>
        <Icon name="sparkles" color="information" type="solid" size="large" />
        <TitleMedium highlightString={t('automate', 'automate?')}>
          {`${t(
            'Hey_what_would_you_like_to_automate',
            'Hey, what would you like to automate',
          )}?`}
        </TitleMedium>
      </div>
      <div className={css.section}>
        <BodyMedium>
          {t(
            'Suggestions_for_current_workflow',
            'Suggestions for current workflow',
          )}
        </BodyMedium>

        {prompts.map((p) => (
          <PromptChip key={p.value} onClick={() => onSelectPrompt(p.value)}>
            {p.label}
          </PromptChip>
        ))}
      </div>
    </div>
  );
};
